import { Chart } from 'chart.js';
import 'chartjs-adapter-date-fns';
import { configure } from 'mobx';
import { AutoInjectContext, registerTimezonePreferenceStore, registerTimezoneStore } from 'Mri.Web.Common';
import * as React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { polyfill } from 'smoothscroll-polyfill';
import '../Styles/app.scss';
import { AccountView } from './Account/AccountView';
import { App } from './Core/App';
import { DisplayListViewModel } from './DisplayFilters/DisplayListViewModel';
import { stores } from './stores/stores';

configure({ enforceActions: 'observed' });
polyfill();

const { accountStore, displaysStore } = stores;

// @TODO fix Sentry
// Sentry.init({
//     dsn: 'https://4d4fde2ae7ce4932b74afdadf32087ac@o4504526605910016.ingest.sentry.io/4504526609252354',
//     integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],
//     autoSessionTracking: true,
//
//     // Set tracesSampleRate to 1.0 to capture 100%
//     // of transactions for performance monitoring.
//     // We recommend adjusting this value in production
//     tracesSampleRate: 1.0,
// });

Sentry.setContext('User', accountStore.user as any);
// Sentry.setContext('DisplayStore', displaysStore)

registerTimezonePreferenceStore(accountStore);
registerTimezoneStore(displaysStore);

DisplayListViewModel.stores = stores;

const container = document.getElementById('app') as HTMLElement;
const root = createRoot(container);

root.render(
    <AutoInjectContext.Provider value={stores}>
        <BrowserRouter>
            <Switch>
                <Route path="/account" component={AccountView} />
                <Route path="/" component={App} />
            </Switch>
        </BrowserRouter>
    </AutoInjectContext.Provider>
);
